@if (!isHubPage() && breadcrumbs()?.length > 0 && breadcrumbs(); as breadcrumbs) {
  <section class="ppg-page-resolver-breadcrumbs-section">
    <ppg-breadcrumbs [breadcrumbs]="breadcrumbs" [rootName]="breadcrumbsHome()" />
  </section>
}

@if (page()) {
  <ng-container [ngComponentOutlet]="pageRendererComponent$ | async" [ngComponentOutletInputs]="componentInputs()" />
}
